export default __webpack_public_path__ + "static/media/tiktok-mono.850d18a6.svg";